module.exports = __webpack_public_path__ + "assets/img/logo_FS.2f8453e6.png";